import { gql } from 'apollo-boost';

export const SEARCH_SPONSORS = gql`
  query SPONSORS {
    sponsors {
      total
      page
      docs {
        id
        name
        logo
      }
    }
  }
`;

export const SPONSOR = gql`
  query SPONSOR($id: ID) {
    sponsor(id: $id) {
      id
      name
      logo
    }
  }
`;

export const ADD_SPONSOR = gql`
  mutation($input: SponsorInput) {
    addSponsor(input: $input) {
      id
    }
  }
`;

export const UPDATE_SPONSOR = gql`
  mutation($input: SponsorInput) {
    updateSponsor(input: $input) {
      id
    }
  }
`;
